import React, { useEffect } from 'react';

const CookieConsentManager = ({ children }: any) => {
	useEffect(() => {
		// Asegúrate de que este código se ejecute solo en el cliente
	}, []);

	return <>{children}</>;
};

export default CookieConsentManager;
